import { Divider, Menu } from "antd";
import { BiCategoryAlt } from "react-icons/bi";
import { BsPostcard } from "react-icons/bs";
import { CiSettings } from "react-icons/ci";
import { FaRegComment, FaRegUser } from "react-icons/fa";
import { GoHome, GoStack } from "react-icons/go";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { IoCalendarClearOutline } from "react-icons/io5";
import { LuClipboardList, LuContact } from "react-icons/lu";
import { MdOutlineContactPhone } from "react-icons/md";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { Link, NavLink, useNavigate } from "react-router-dom";
import LookFindrLogo from "../../../assets/images/LookfindrLogo";
import queryClient from "../../../services/react-query/queryClient";
import {
  setLocationId,
  setSelectedTeamMember,
} from "../../../services/store/slices/calender";
import { emptyStep } from "../../../services/store/slices/onboarding";
import { setUserData } from "../../../services/store/slices/user";
import { AiOutlineTransaction } from "react-icons/ai";

const menuItems: any = [
  {
    key: "admin/overview",
    id: "Dashboard overview",
    defaultMessage: "Dashboard overview",
  },
  {
    key: "admin/salon-management",
    id: "Salon management",
    defaultMessage: "Salon management",
  },
  {
    key: "admin/clients-management",
    id: "Clients management",
    defaultMessage: "Clients management",
  },
  {
    key: "admin/appointments",
    id: "Appointments",
    defaultMessage: "Appointments",
  },
  {
    key: "admin/staff-management",
    id: "Staff management",
    defaultMessage: "Staff management",
  },
  {
    key: "admin/catalog-management",
    id: "Catalog management",
    defaultMessage: "Catalog management",
  },
  // {
  //   key: 'admin/reports-analytics',
  //   id: 'Reports & Analytics',
  //   defaultMessage: 'Reports & Analytics',
  // },
  // {
  //   key: 'admin/settings',
  //   id: 'Settings',
  //   defaultMessage: 'Settings',
  // },
  // {
  //   key: 'admin/help-support',
  //   id: 'Help & Support',
  //   defaultMessage: 'Help & Support',
  // },
  {
    key: "admin/blogs",
    id: "Blogs",
    defaultMessage: "Blogs",
  },
  {
    key: "admin/blog-categories",
    id: "Blog Categories",
    defaultMessage: "Blog Categories",
  },
  {
    key: "admin/contact-us-requests",
    id: "Contact us requests",
    defaultMessage: "Contact us requests",
  },
  // {
  //   key: 'admin/transaction',
  //   id: 'transaction',
  //   defaultMessage: 'transaction',
  // },
];
const icons = [
  <GoHome className="w-6 h-6" />,
  <HiOutlineLocationMarker className="w-6 h-6" />,
  <LuContact className="w-6 h-6" />,
  <IoCalendarClearOutline className="w-6 h-6 font-semibold" />,
  <FaRegUser className="w-5 h-5" />,
  <GoStack className="w-6 h-6" />,
  // <LuClipboardList className="w-6 h-6" />,
  // <CiSettings className="w-6 h-6" />,
  // <FaRegComment className="w-6 h-6" />,
  <BsPostcard className="w-6 h-6" />,
  <BiCategoryAlt className="w-6 h-6" />,
  <MdOutlineContactPhone className="w-6 h-6" />,
];
function getItem(key: any, intl: any, i: number) {
  return {
    key,
    label: (
      <NavLink
        to={`/${key}`}
        className={({ isActive }) =>
          isActive
            ? "!text-color-primary !text-base !font-semibold !bg-white flex items-start justify-start w-full h-full"
            : "!text-[#9999A7] !text-sm !font-normal !bg-white flex items-start justify-start w-full h-full"
        }
      >
        {intl.formatMessage({
          id: key,
          defaultMessage: menuItems?.find((item: any) => item?.key === key)
            .defaultMessage,
        })}
      </NavLink>
    ),
    children: null,
    icon: icons[i],
  };
}

export default function AdminMenu({ collapsed, setCollapsed }: any) {
  const intl = useIntl();
  const navigate = useNavigate();
  const items = menuItems?.map((item: any, i: number) =>
    getItem(item?.key, intl, i)
  );
  const dispatch = useDispatch();

  return (
    <div className="adminMenu">
      <div className="flex items-center justify-start pt-12 pl-6 bg-white demo-logo-vertical">
        <Link to="/admin/overview">
          <LookFindrLogo className="" />
        </Link>
      </div>
      <Divider />
      <Menu
        mode="inline"
        items={items}
        style={{ width: "100%", background: "white" }}
        className="flex flex-col items-center justify-center w-full text-center"
        onClick={({ key }) => navigate("/" + key)}
      />
      <div
        onClick={() => {
          dispatch(setUserData(null));
          dispatch(setLocationId(null));
          dispatch(setSelectedTeamMember(null));
          dispatch(emptyStep([]));
          queryClient.clear();
          localStorage.clear();
          navigate("/login");
          return;
        }}
        className="pl-6 text-[#C43535] text-base mt-10 cursor-pointer w-fit"
      >
        log out
      </div>
    </div>
  );
}
